import React from "react";
import BaseCard from "./BaseCard";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import CardHeader from "./CardHeader";
import NoteCard from "./NoteCard";
import DataTable from "../../../../Elements/DataTable/DataTableFigma";
import moneyHelper from '../../../../Helpers/moneyHelper';

class ShopperTravelCostCard extends BaseCard {
  FieldsToShowInDataTable = () => {
    return [
      { label: "Tier Name", data: "Name", type: InputTypesEnum.TextReadOnly, tableminWidth: "625px" },
      {
        label: "TOTAL Budget Per Cycle",
        data: "TravelCostPerCycle",
        type: InputTypesEnum.Text2,
        tableminWidth: "125px",
        fieldType: "Decimal",
      },
      {
        label: "TOTAL Budget Annually",
        data: "TravelCostAnnually",
        tableminWidth: "125px",
        headerPosition: "header-text-right",
      },
      {
        label: "% of revenues",
        data: "TravelCostPct",
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: "125px",
        headerPosition: "header-text-right",
      },
    ];
  };

  FieldsToShowInFooterDataTable() {
    return [
      { label: " ", tableminWidth: "625px" },
      { label: "Total travel cost", tableminWidth: "125px", headerPosition: "header-text-right" },
      { label: "", data: "TravelCostAnnuallyTotal", tableminWidth: "125px", headerPosition: "header-text-right" },
      { label: "", data: "TravelCostpct", tableminWidth: "125px", headerPosition: "header-text-right" },
    ];
  }

  render() {
    return (
      <div className='card'>
        {
          <CardHeader
            sectionNumber={'4'}
            HeaderText={'SHOPPER TRAVEL COST'}
            changeBodyStatus={this.changeBodyStatus}
            bodyactive={this.state.bodyactive}
            subtotal={moneyHelper.toMoneyFormat(this.props.Tier.TravelCostAnnuallyTotal, this.props.Tier.PricingDetails.CurrencyCode)}
            subtotalRev={this.props.Tier.TravelCostpct + ' of revenue'}
          />
        }
        {this.state.bodyactive ? (
          <div>
            <NoteCard
              noteActive={this.state.noteActive}
              renderInputField={this.renderInputField}
              name='ShopperTravelCostNotes'
              value={this.props.Tier.PricingDetails}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={this.props.Tier.TierList}
              renderInputFieldFunction={this.renderInputField}
              thereIsNoSuchRowMessageCheck={false}
              smallDataTable={true}
            />
          </div>
        ) : null}
        <footer>
          <DataTable
            type={{
              FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
              MoneyFields: this.MoneyFields,
              Currency: this.Currency,
            }}
            headeritemList={this.props.Tier}
            thereIsNoSuchRowMessageCheck={false}
            smallDataTable={true}
          />
        </footer>
      </div>
    );
  }
}

export default ShopperTravelCostCard;
